import { FLASH_TIMER, FAST_TIMER } from '~/const/timers';
export default {
  name: 'MdmLayer',
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      childTitle: '',
      initialPageYOffset: 0,
      open: false,
      component: null,
      shouldClose: true,
      prevCmp: null,
      payload: {}
    };
  },
  mounted() {
    this.$root.$on('open-layer', payload => {
      this.payload = payload;
      if (this.component !== null) {
        this.shouldClose = false;
        this.prevCmp = this.component;
      }
      this.childTitle = payload.context;
      this.component = () => this.getLayer(payload.name);
      setTimeout(() => {
        this.handleLayer(payload.state);
      }, FLASH_TIMER);
    });
  },
  beforeDestroy() {
    this.$root.$off('open-layer');
  },
  methods: {
    handleLayer(state) {
      this.disableWindowScroll();
      this.bindEscKey();
      this.open = state;
    },
    closeLayer() {
      if (this.shouldClose === false) {
        this.component = this.prevCmp;
        this.prevCmp = null;
        this.shouldClose = true;
      } else {
        this.open = false;
        this.enableWindowScroll();
        this.unbindEscKey();
        setTimeout(() => {
          this.component = null;
        }, FAST_TIMER);
      }
    },
    bindEscKey() {
      document.addEventListener('keyup', this.handleKeyUp, {
        passive: true
      });
    },
    unbindEscKey() {
      document.removeEventListener('keyup', this.handleKeyUp);
    },
    handleKeyUp(e) {
      if (e.keyCode === 27) {
        this.closeLayer();
        return false;
      }
      return false;
    },
    getLayer(slug) {
      this.component = () => import("./Layers/".concat(slug));
    }
  }
};